// extracted by mini-css-extract-plugin
export var flush = "HbJtGbedyVyrowe2HVMv";
export var headerWithIcon = "oDk5BDsYvV2lMoW4EsxW";
export var leftBorder = "P6WrFFIObKT2akKRTgaG";
export var leftBorderInfo = "Qsk_V6ZsXg8BDxnvKt2y";
export var leftBorderNegative = "XRfVk7Hna7H_pOWedLKE";
export var leftBorderPositive = "p1r2OcKGe97V0LYq_RSV";
export var leftBorderWarning = "sYofPubMrWtRsnEwDYWQ";
export var message = "v0NFWGrsJHxz77WDvPOQ";
export var messageHeader = "YBB5tENFxnMdw4e109oI";
export var trailingItem = "ZI4Jov3sVcGR9jCSz0Zf";
export var vertical = "q2GzrpzHuIqi_hocGsaw";